var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('Saved Report'))+" "),_c('a',{attrs:{"href":'/Atlas/View/SavedReport?SavedReportID=' + _vm.notificationData.savedReportId}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.notificationData.name)}})]),_vm._v(" "+_vm._s(_vm.notificationData.updated ? _vm.$t('was updated') : _vm.$t('was viewed'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }